import React from "react";

const Loading = () => {
    return (
        <div style={{ height: "100vh", textAlign: "center" }}>
            <h1 className="text-xl mt-4">Loading...</h1>
        </div>
    );
};

export default Loading;
